import { createI18n, I18n } from 'vue-i18n'
import it from './it.json'
import en from './en.json'
import enErrors from '@volverjs/zod-vue-i18n/locales/v4/en.json'
import itErrors from '@volverjs/zod-vue-i18n/locales/v4/it.json'

const SUPPORTED_LOCALES = ['it', 'en'] as const
type SupportedLocale = (typeof SUPPORTED_LOCALES)[number]

function detectLocale(): SupportedLocale {
    const browserLang = navigator.language.split('-')[0]
    return (SUPPORTED_LOCALES as readonly string[]).includes(browserLang)
        ? (browserLang as SupportedLocale)
        : 'en'
}

/*
 * Setup i18n
 * https://vue-i18n.intlify.dev/
 */
export const i18n = createI18n({
    legacy: false,
    locale: detectLocale(),
    globalInjection: true,
    fallbackWarn: false,
    messages: {
        it: {
            ...it,
            errors: { ...itErrors, ...it.errors },
        },
        en: {
            ...en,
            errors: { ...enErrors, ...en.errors },
        },
    },
    numberFormats: {
        it: {
            currency: {
                style: 'currency',
                currency: 'EUR',
                notation: 'standard',
            },
            currencyUSD: {
                style: 'currency',
                currency: 'USD',
                notation: 'standard',
                maximumFractionDigits: 4,
            },
            decimal: {
                style: 'decimal',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            },
            integer: {
                style: 'decimal',
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
                useGrouping: true,
            },
        },
        en: {
            currency: {
                style: 'currency',
                currency: 'EUR',
                notation: 'standard',
            },
            currencyUSD: {
                style: 'currency',
                currency: 'USD',
                notation: 'standard',
                maximumFractionDigits: 4,
            },
            decimal: {
                style: 'decimal',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            },
            integer: {
                style: 'decimal',
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
                useGrouping: true,
            },
        },
    },
    datetimeFormats: {
        it: {
            short: {
                dateStyle: 'short',
            },
            'date-time': {
                dateStyle: 'short',
                timeStyle: 'short',
            },
            time: {
                timeStyle: 'short',
            },
        },
        en: {
            short: {
                dateStyle: 'short',
            },
            'date-time': {
                dateStyle: 'short',
                timeStyle: 'short',
            },
            time: {
                timeStyle: 'short',
            },
        },
    },
}) as unknown as I18n<
    Record<string, unknown>,
    Record<string, unknown>,
    Record<string, unknown>,
    string,
    false
>
